export const PLAYER_MAP_ROLES = {
  ATTACKER: 'ATTACKER',
  DEFENDER: 'DEFENDER',
  SPECTATOR: 'SPECTATOR',
};